export const publicRuntimeConfig = {
  appName: 'traeger' as const,
  auth: {
    url: process.env.NEXT_PUBLIC_AUTH_API_URL ?? 'https://auth-api.iot.traegergrills.io',
  },
  bv: {
    environment: process.env.NEXT_PUBLIC_BV_ENVIRONMENT ?? 'production',
  },
  locally: {
    companyId: process.env.NEXT_PUBLIC_LOCALLY_COMPANY_ID ?? 112256,
    companyName: process.env.NEXT_PUBLIC_LOCALLY_COMPANY_NAME ?? 'Traeger%20Grill',
  },
  onetrust: {
    key: process.env.NEXT_PUBLIC_ONETRUST_KEY ?? '0bc914fb-a65b-4a15-b6c7-05e997712a72',
  },
  segment: {
    writeKey: process.env.NEXT_PUBLIC_ANALYTICS_WRITE_KEY,
  },
  sentry: {
    dsn:
      (process.env.NODE_ENV !== 'development' || !!process.env.NEXT_PUBLIC_USE_SENTRY) &&
      process.env.NEXT_PUBLIC_SENTRY_DSN,
    environment: process.env.NEXT_PUBLIC_SENTRY_ENV,
  },
  reCaptcha: {
    sitekey: process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY,
  },
  loadMarketingScripts: process.env.NEXT_PUBLIC_LOAD_MARKETING_SCRIPTS,
  base: process.env.NEXT_PUBLIC_WEB_ENV ?? 'https://www.traeger.com',
};
